import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button, Input } from '../../../../components/base';
import ContentTable from '../../../../components/ContentTable/ContentTable.component';
import { FINANCE_NON_KAS_JOURNAL_TABLE_FIELDS } from '../../../../constants/finance/bookeeping.constant';

export default class NonKasJournal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
  }

  _onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-non-kas', { isEdit: false });
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-non-kas', { data: { id: val.id }, isEdit: true });
  }

  _onFormChange(event) {
    const {
      name,
      value,
    } = event.target;
    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          [name]: value,
        },
        error: {
          ...prevState.form.error,
          [name]: '',
        },
      },
    }));
  }

  render() {
    const { form } = this.state;
    const { handleGetNonKasJournal } = this.props;
    return (
      <div className="non-kas-journal">
        <div className="non-kas-journal__add-button">
          <Button
            title="Tambah Jurnal Non Kas"
            onClick={this._onClickAdd}
          />
        </div>
        <div className="non-kas-journal__date">
          <Input
            type="date"
            name="date"
            value={form.value.date}
            onChange={this._onFormChange}
          />
        </div>
        <div className="non-kas-journal__content">
          <ContentTable
            onSearchContent={handleGetNonKasJournal}
            tableFields={FINANCE_NON_KAS_JOURNAL_TABLE_FIELDS}
            onClickEdit={this._onClickEdit}
            showDelete={false}
            customThead={(
              <thead>
                <tr>
                  <th rowSpan={2}>No</th>
                  <th rowSpan={2}>Tanggal</th>
                  <th colSpan={2}>Akun</th>
                  <th rowSpan={2}>Keterangan</th>
                  <th rowSpan={2}>Debet</th>
                  <th rowSpan={2}>Kredit</th>
                  <th rowSpan={2}>&nbsp;</th>
                </tr>
                <tr>
                  <th>Kode</th>
                  <th>Nama</th>
                </tr>
              </thead>
            )}
          />
        </div>
      </div>
    );
  }
}
NonKasJournal.propTypes = {
  handleGetNonKasJournal: PropTypes.func,
  history: PropTypes.object.isRequired,
};
NonKasJournal.defaultProps = {
  handleGetNonKasJournal: noop,
};
